import React, { Fragment, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import NavbarStandard from '../navbar/NavbarStandard';
import Banner from './Banner';
import Partners from './Partners';
import Processes from './Processes';
import Services from './Services';
import Testimonial from './Testimonial';
import Cta from './Cta';
import FooterStandard from './FooterStandard';

const Landing = () => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return (
    <Fragment>
      <NavbarStandard />
      <Banner />
      <Partners />
      <Processes />
      <Services />
      <Testimonial />
      <Cta />
      <FooterStandard />
    </Fragment>
  );
};

export default Landing;
